export class CookiesService {
  private readonly COOKIE_NAME = 'chat_session_id';
  private readonly EXPIRATION_DAYS = 1;

  /**
   * Gets chat session ID from cookie
   * @returns Chat session ID or undefined if not found
   */
  public getSessionCookie(): string | undefined {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === this.COOKIE_NAME) {
        return value;
      }
    }
    return undefined;
  }

  /**
   * Sets chat session ID in cookie
   * @param chatSessionId Chat session ID to save
   */
  public setSessionCookie(chatSessionId: number): void {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + this.EXPIRATION_DAYS);
    
    document.cookie = `${this.COOKIE_NAME}=${chatSessionId}; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax`;
  }

  /**
   * Clears session cookie
   */
  public clearSessionCookie(): void {
    document.cookie = `${this.COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }

  /**
   * Gets generic cookie value
   * @param name Cookie name
   * @returns Cookie value or undefined if not found
   */
  public getCookie(name: string): string | undefined {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const [cookieName, cookieValue] = cookie.trim().split('=');
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return undefined;
  }

  /**
   * Sets generic cookie
   * @param name Cookie name
   * @param value Cookie value
   * @param days Days until expiration
   */
  public setCookie(name: string, value: string, days: number): void {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + days);
    
    document.cookie = `${name}=${value}; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax`;
  }
} 